import { getUserInteractionContext } from 'owa-mail-triage-patterns';
import { isFeatureEnabled } from 'owa-feature-flags';
import { userMailInteractionAction, ActionType } from 'owa-mail-actions';
import { InstrumentationContext } from 'owa-mail-store';
import { TableView } from 'owa-mail-list-store';

/**
 * method to abstract out raising userMailInteractionAction
 * @param conversationRowKeys row keys used to get sender data
 * @param tableView table view used to get sender data
 * @param instrumentationContexts used for search scenario
 * @param actionType action type which will be logged
 * @param folderId folder to which move action was performed
 */
export default function logUserMailInteraction(
    conversationRowKeys: string[],
    tableView: TableView,
    instrumentationContexts: InstrumentationContext[],
    actionType: ActionType,
    folderId?: string
) {
    let triageContext;
    if (isFeatureEnabled('tri-triagePattern')) {
        triageContext = getUserInteractionContext(
            conversationRowKeys,
            tableView,
            actionType,
            folderId
        );
    }
    userMailInteractionAction(actionType, instrumentationContexts, triageContext);
}
